import { AddNewStakeholderModal } from './AddNewStakeholderModal';
import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';

import React, { useRef } from 'react';
import { useCurrentUser, useToggle } from '@hooks';

export const AddNewStakeholderButton: React.FC = () => {
	const { isReadOnly } = useCurrentUser();
	const [ isOpen, toggle ] = useToggle(false);
	const buttonRef = useRef<HTMLButtonElement>(null);

	if (isReadOnly) {
		return null;
	}

	return (
		<>
			<Button
				onClick={ toggle }
				ref={ buttonRef }
				type='primary'>
				{ COPY_SPECIFIC.ADD_NEW_STAKEHOLDER }
			</Button>
			<AddNewStakeholderModal
				isOpen={ isOpen }
				onCancel={ toggle }
				popoverPosition='bottomRight'
				popoverTarget={ buttonRef } />
		</>
	);
};
